import React from 'react';
import { Briefcase, MapPin } from 'lucide-react';
import { profileData } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16 opacity-0 animate-fadeInUp">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Work Experience
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
        </div>

        <div className="space-y-8">
          {profileData.experience.map((exp, index) => (
            <div
              key={exp.id}
              className="bg-white dark:bg-gray-900 rounded-3xl p-8 md:p-10 shadow-sm hover:shadow-xl transition-all duration-500 transform hover:-translate-y-2 opacity-0 animate-fadeInUp"
              style={{ animationDelay: `${200 + index * 150}ms` }}
            >
              <div className="flex flex-col md:flex-row md:items-start md:justify-between mb-6">
                <div className="flex-1">
                  <div className="flex items-center space-x-4 mb-4">
                    <div className="w-16 h-16 bg-white dark:bg-gray-800 rounded-xl p-3 shadow-md flex items-center justify-center overflow-hidden border border-gray-100 dark:border-gray-700">
                      <img 
                        src={exp.logo} 
                        alt={`${exp.company} logo`}
                        className="w-full h-full object-contain"
                        loading="lazy"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.parentElement.innerHTML = `<div class="text-2xl font-bold text-blue-600 dark:text-blue-400">${exp.company.charAt(0)}</div>`;
                        }}
                      />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 dark:text-white">
                        {exp.role}
                      </h3>
                      <div className="flex items-center space-x-2 text-blue-600 dark:text-blue-400 font-medium">
                        <Briefcase className="w-5 h-5" />
                        <span>{exp.company}</span>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 text-gray-500 dark:text-gray-400 text-sm ml-20">
                    <MapPin className="w-4 h-4" />
                    <span>{exp.location}</span>
                  </div>
                </div>
                <div className="mt-4 md:mt-0">
                  <span className="inline-block px-4 py-2 bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 rounded-full text-sm font-medium">
                    {exp.duration}
                  </span>
                </div>
              </div>

              <div className="space-y-3 ml-0 md:ml-20">
                {exp.achievements.map((achievement, idx) => (
                  <div key={idx} className="flex items-start space-x-3 group">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <p className="text-gray-600 dark:text-gray-300 leading-relaxed group-hover:text-gray-900 dark:group-hover:text-white transition-colors duration-300">
                      {achievement}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;